import { render, staticRenderFns } from "./SelectAudienceModal.vue?vue&type=template&id=38eb4c41&scoped=true"
import script from "./SelectAudienceModal.vue?vue&type=script&lang=js"
export * from "./SelectAudienceModal.vue?vue&type=script&lang=js"
import style0 from "./SelectAudienceModal.vue?vue&type=style&index=0&id=38eb4c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb4c41",
  null
  
)

export default component.exports